<template>
  <div class="flex justify-end">
        <a :href="`/panels/floors/${uuid}/events`" class="mr-2">
            <button-secondary>
                <template slot="icon"><i class="fa fa-television"></i></template>
                Event-Monitor anzeigen
            </button-secondary>
        </a>
    </div>
</template>

<script>
import ButtonSecondary from "../components/UI/ButtonSecondary";
export default {
    name: "FloorEventsPanelSelect",
    components: {
        ButtonSecondary
    },

    props: ['uuid'],

}
</script>